import Popup from './Popup';

const Popups = {
  Popup
};

module.exports = Popups;



// WEBPACK FOOTER //
// ./src/ui/Popup/index.js